namespace JupitersChoice {
    
    export class InitBigWinClickHandlerCmd {

        @inject('BigWinModel') _bigWinModel: BigWinModel;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            this._layerManager.getLayerById('BigWin').on('click',() => {
                this._bigWinModel.dismiss();
            })
            this._layerManager.getLayerById('BigWin').on('tap',() => {
                this._bigWinModel.dismiss();
            })
        }
    }
}